module.exports = __webpack_public_path__ + "static/media/google-play.4ebd2789.svg";